import React from "react";
import type { LucideIcon } from "lucide-react";

import { Message, MessageContent } from "@/components/ai-elements/message";
import { Tag } from "@/components/ui/tag";

type Attachment = {
  label: string;
  icon: LucideIcon;
};

type Props = {
  content: string;
  timestampLabel?: string;
  attachments?: Attachment[];
  sources?: { label: string; icon: LucideIcon }[];
};

export function MessageBubbleUser({
  content,
  timestampLabel,
  attachments = [],
  sources = []
}: Props) {
  return (
    <Message from="user">
      <MessageContent>
        <span className="w-full min-w-0 text-left wrap-break-word wrap-anywhere whitespace-pre-wrap">
          {content}
        </span>

        {attachments.length || sources.length ? (
          <div className="flex flex-wrap items-center justify-start gap-1.5 self-stretch">
            {attachments.map(({ label, icon: Icon }) => (
              <Tag key={`att-${label}`} title={label}>
                <Icon aria-hidden />
                {label}
              </Tag>
            ))}
            {sources.map(({ label, icon: Icon }) => (
              <Tag key={`src-${label}`} title={label}>
                <Icon aria-hidden />
                {label}
              </Tag>
            ))}
          </div>
        ) : null}

        {timestampLabel ? (
          <span className="text-sm text-fg-3">{timestampLabel}</span>
        ) : null}
      </MessageContent>
    </Message>
  );
}
